const CashClosingEndPoints =  {
    GET_USER: `/api/seller`,
    GET_CASH_CLOSING: `/api/invoice/closingCashRegister/ByDateForSeller`,
}

export default CashClosingEndPoints